import {css} from '@yandex-delivery/blocks/theme/css'

import {spacing} from '../theme/theme'
import {cssTheme} from '../v2/theme'

export const root = css`
  &:hover {
    transition: all 0.25s ease-out;
  }

  &:active {
    transition: all 0.15s ease-out;
  }
`

export const light = css`
  padding-inline: ${spacing(2.75)};
  padding-block: ${spacing(1.625)};
  border: 1px solid ${cssTheme.default.day.everWhite};
  background-color: ${cssTheme.default.day.everWhite};
  color: ${cssTheme.default.day.everBlack};

  &:hover {
    // TODO: Добавить цвет в cssTheme
    background-color: #dedede;
    border-color: #dedede;
  }

  &:active {
    // TODO: Добавить цвет в cssTheme
    background-color: #bebebe;
    border-color: #bebebe;
  }
`

export const dark = css`
  padding-inline: ${spacing(4.25)};
  padding-block: ${spacing(1.45)};
  background-color: #21201f;

  &:hover {
    border-color: #2f2f2f;
  }

  &:active {
    border-color: #464646;
  }
`
